export default "__VITE_ASSET__a2f99848__"